// extracted by mini-css-extract-plugin
var _1 = "b31ddf";
export { _1 as "audio_player_head_controls" }
